<template>
  <div
    v-if="show"
    @click.self="handleClickClose(false)"
    class="raise-box-wrapper"
    :style="{
      ...styleVar,
      backgroundColor: propStyleVar.maskColor ? propStyleVar.maskColor + '!important' : ''
    }"
    :class="[className, isBottomPosition && 'is-bottom-position']"
  >
    <div
      class="raise-box-content"
      :class="{ packageLogo: packageLogo, singsong: bottomBar, 'content-out': isCloseAnimation }"
    >
      <div v-if="showTopImg" class="raise-box-top">
        <img :src="showTopImg">
      </div>
      <div v-if="showTopText" class="raise-box-top-text">{{ showTopText }}</div>
      <div v-if="showTopAnimation" class="raise-box-top-animation">
        <img
          :src="showTopAnimation"
          :class="{'breathing': true}"
        >
      </div>
      <div class="content-bg" @click="handleClickContent">
        <div v-if="showUserAvatar" class="user-avatar" :class="[userAvatarClass]">
          <img v-if="showCrown" :class="['crown-icon', propStyleVar.crownClass]" :src="propStyleVar.crownUrl || 'https://qncweb.ktvsky.com/20250423/vadd/bbb86fa5fd27310e3dd11d2f57976973.png'">
          <img class="user_img" :src="user_img">
          <span v-if="propStyleVar.showExpireImg ? propStyleVar.showExpireImg : role === 'role4'" class="expire-img"></span>
        </div>
        <div class="avatar-text" :class="[avatarTextClass]">
          <div v-if="showUserAvatarText" class="avatar-new">
            <img :src="user_img">
            <span class="expire-img"></span>
          </div>
          <div class="user-nickname">{{ processedUserAvatarText }}</div>
        </div>
        <h1 v-if="showRole4Title" class="expire">您的VIP已经过期{{expireDays}}天</h1>
        <div v-if="showTip" class="tip-area" @click="handleClickTip"></div>
        <progressive-img
          :src="contentBg"
          :placeholder="contentBg + '?imageView2/0/w/38'"
        />
      </div>
      <div
        v-if="showPackageTopHot && showThreeTiersPayment"
        class="package-top-hot"
        :style="packageTopHotStyle"
        @click.stop="handlePackageTopHotClick"
      ></div>
      <div class="main-content">
        <div v-if="showConfigTitles" class="config-title-area">
          <div
            v-if="effectiveMainTitle"
            class="config-main-title"
            :style="mainTitleStyle"
          >{{ effectiveMainTitle }}</div>
          <div
            v-if="effectiveSubTitle"
            class="config-sub-title"
            :style="subTitleStyle"
          >{{ effectiveSubTitle }}</div>
        </div>
        <!-- 新增文案显示区域 -->
        <div v-if="showTopUserCount" class="top-user-count">
          <transition name="slide-up" mode="out-in">
            <div :key="currentUserCount" class="count-text">
              超值！今日已有<span class="count-number">{{ currentUserCount }}</span>人选择月卡
            </div>
          </transition>
        </div>
        <!-- VIP专享热歌限定 test-->
        <swiper
          v-if="hotsongSwiperData.length"
          :options="hotsongSwiperOption"
          class="hotsong-swiper"
        >
          <swiper-slide v-for="(item, index) in hotsongSwiperData" :key="index">
            <div class="song-item">
              <div class="song-info">
                <span class="song-name">{{
                  item.musicName.length > 6
                    ? `${item.musicName.slice(0, 6)}...`
                    : item.musicName
                }}</span>
              </div>
              <div class="song-user">
                <img v-if="mikeurl" class="mike" :src="mikeurl" />
                <img
                  v-else-if="item.isCc"
                  class="mike"
                  src="https://qncweb-back1.ktvsky.com/20211122/vadd/41014f97d637040cb2be5ab1ebec07a2.png"
                />
                <img
                  v-else
                  class="mike"
                  src="https://qncweb-back1.ktvsky.com/20211123/vadd/6eea6b9c5fc66baf1d068061b79abc32.png"
                />
                <span
                  class="song-tips"
                  :class="!item.isCc && 'recomend-songs'"
                  >{{ item.content || item.count }}</span
                >
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <!-- VIP专享热歌限定  end -->
        <div v-if="swiperData.length" class="swiper-wrappper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in swiperData" :key="index">
              <img :src="item" />
            </swiper-slide>
            <div
              v-if="swiperData.length > 1"
              class="swiper-pagination"
              slot="pagination"
            ></div>
          </swiper>
        </div>
        <div v-if="propStyleVar.isShowTopTap" class="tap-top">{{ propStyleVar.isShowTopTap }}</div>
        <template v-if="showThreeTiersPayment">
          <ul class="packages-ul" :class="excludesId && 'packages-ul1'" :style="packagesStyle">
            <li
              v-for="(item, index) in packages"
              :key="index"
              :class="{
                selected: index === selectIndex,
              }"
              :style="packagesliStyle"
              @click="choosePackage(index)"
            >
              <div class="desc">
                <p v-if="packagesContent.origin">
                  {{ packagesContent.month[index] }}
                </p>
                <p v-else>{{ item.desc.split('plus')[0] }}</p>
                <img
                    v-if="propStyleVar.plusUrl && !hidePlus && item.desc.includes('plus') && !packageLogo"
                    :src="propStyleVar.plusUrl"
                    class="icon-img-plus">
                <svg-icon
                  v-else-if="!hidePlus && item.desc.includes('plus') && !packageLogo"
                  :icon-class="propStyleVar.plusSvg"
                  class="icon-plus"
                />
              </div>
              <div class="month-price">
                <p v-if="(isMonthDiscount || isShowDiscountDayFee) && index == discountIndex">
                  ¥<span>{{ discountDayFee }}</span>/小时
                </p>
                <p
                  v-else-if="packagesContent.current"
                  v-html="packagesContent.current[index]"
                ></p>
                <p v-else>
                  ¥<span>{{ item.day_fee }}</span>/小时
                </p>
              </div>
              <!-- 月会员调整 -->
              <div
                class="price"
                :style="!hideLine"
              >
                <template v-if="packagesContent.origin">
                  <img
                    v-if="packagesContent.origin[index].includes('http')"
                    :src="packagesContent.origin[index]"
                  />
                  <span v-else v-html="packagesContent.origin[index]"></span>
                </template>
                <span v-else>
                  ¥{{ index === 0 ? item.origin_fee : item.current_fee / 100 }}
                  <span v-if="item.cur_fee" style="text-decoration: line-through;">¥{{ item.origin_fee }}</span>
                </span>
              </div>
              <div
                v-if="(packagesContent.showTag || item.save_tip) && packagesContent.tagContent[index] && !isTagHiddenByTopCountdown(index)"
                class="tag"
              >
                <template v-if="packagesContent.tagContent">
                  <img
                    v-if="packagesContent.tagContent[index].includes('http')"
                    :src="packagesContent.tagContent[index]"
                  />
                  <span v-else>{{ packagesContent.tagContent[index] }}</span>
                </template>
                <span v-else>{{ setTip(item.save_tip, index) }}</span>
              </div>
              <div v-if="index === (packagesContent.discountTapIndex != null ? packagesContent.discountTapIndex : discountIndex) && packagesContent.topTapText" class="top-tap">{{ packagesContent.topTapText }}</div>
              <div v-if="index === (packagesContent.discountTapIndex != null ? packagesContent.discountTapIndex : discountIndex) && packagesContent.bottomTip" class="bottom-tip">{{ packagesContent.bottomTip }}</div>
              <div
                v-if="!isShowBtnCountDown && !isShowTextCountDown && (packagesContent.countdownIndex != null ? index === packagesContent.countdownIndex : isMonthDiscount && index == discountIndex) && !noShowCountDown"
                class="tip"
                :class="{
                  'tip1': packagesContent.countdownText,
                  'topTip': packagesContent.countdownTtop,
                  'hongbao-tip': isShowHongBao,
                }"
              >
                <countdown
                  :end-time="new Date().getTime() + 1000 * 60 * (packagesContent.countdownTime || 5)"
                  ref="countdown"
                  @finish="handleCountDownFinish"
                >
                  <span
                    slot="process"
                    slot-scope="timeScop"
                    class="countdown"
                  >
                    <template v-if="!packagesContent.countdownSuffixText">
                      {{ packagesContent.countdownText || '限时' }}:
                    </template>
                    <span v-if="packagesContent.showCountdownH">{{ timeScop.timeObj.h }}:</span>
                    <span>{{ timeScop.timeObj.m }}:</span>
                    <span>{{ timeScop.timeObj.s }}</span>
                    <span v-if="!packagesContent.showCountdownH">:{{ String(milliseconds).padStart(2, '0') }}</span>
                  </span>
                  <template v-if="packagesContent.countdownSuffixText">
                    {{ packagesContent.countdownSuffixText }}
                  </template>
                </countdown>
                <img v-if="isShowHongBao" class="hongbao-icon" src="https://qncweb.ktvsky.com/20251126/vadd/8b13fb9e3c0e360aa7f3c49cc407546a.png" alt="红包">
              </div>
            </li>
          </ul>
          <AddOneYuan
            v-if="isShowAddOnePackages"
            :selectIndex="selectIndex"
            @slectedAddOneYuan="slectedAddOneYuan"
            :selected="isChooseAddOneYuan"
          ></AddOneYuan>
          <template>
            <!-- 新增一个 flex 容器 -->
            <div class="flex-container" :style="{ flexDirection: 'column' }">
              <div :style="{ order: shouldSwap ? 2 : 1 }">
                <GiveFriend
                  v-if="isShowGiveFriend"
                  @presentVipClick="presentVipClick"
                  :presentVipSelected="isChooseGiveFriend"
                  :config="giveFriendConfig"
                ></GiveFriend>
              </div>

              <template v-if="isShowTextCountDown">
                <div
                  class="text_countdown"
                  :class="{
                    'text_countdown1': isShowGiveFriend,
                    'text_countdown_big': isShowTextCountDownBig,
                  }"
                  :style="{ order: shouldSwap ? 1 : 2 }"
                >
                  <countdown
                    :end-time="new Date().getTime() + 1000 * 60 * (packagesContent.countdownTime || 5)"
                    ref="countdown"
                    @finish="handleCountDownFinish"
                  >
                    <span
                      slot="process"
                      slot-scope="timeScop"
                      class="countdown"
                    >
                      <template v-if="!countdownSuffixText">
                        <template v-if="countdownPrefixText">
                          {{ countdownPrefixText }}
                        </template>
                        <template v-else>
                          {{ isShowTextCountDownBig ? '优惠剩余' : '距优惠结束仅剩' }}
                        </template>
                      </template>
                      <span>{{ timeScop.timeObj.m }}&nbsp;:</span>
                      <span>{{ timeScop.timeObj.s }}&nbsp;:</span>
                      <span>{{ String(milliseconds).padStart(2, '0') }}</span>
                      <template v-if="countdownSuffixText">
                        {{ countdownSuffixText }}
                      </template>
                    </span>
                  </countdown>
                </div>
              </template>
            </div>
          </template>
          <div
            :class="[
              {
                'new-foot-bar': isShowFootbar,
                'pay_stay90': isShowCloseBtn,
                'pay-button-countdown': isShowBtnCountDown,
              },
              page_tp,
              songItem.type,
            ]"
          >
            <div v-if="isShowCloseBtn" @click="handleClickCloseButton"></div>
            <div
              class="pay-button"
              @click="handleClickBuyButton"
            >
              <img
                v-if="(page_tp === 'new_oldvip_kaiping' || page_tp === 'Bnew_oldvip_kaiping') && role === 'role4'"
                class="pay-button-tab"
                src="https://qncweb.ktvsky.com/20260416/vadd/b1380f7a4ff60806b54ed775706e9750.png"
                alt=""
              />
              <div v-if="pkgsDes.length && pkgsDes[selectIndex]" class="tip">{{pkgsDes[selectIndex]}}</div>
              <div v-if="ButtonTip.length && ButtonTip[selectIndex]" class="button-tip-new" :class="buttonTipClassName">{{ButtonTip[selectIndex]}}</div>
              <img v-if="isShowFootbar && showOriginal && songItem.sno" src="https://qncweb-back1.ktvsky.com/20220920/vadd/cc07e718e228c09afe893c9ec6540d81.png" class="pay-button-tip">
              <template v-if="packagesContent.button">
                <img
                  :src="
                    selectIndex === 2
                      ? packagesContent.plusButton
                      : packagesContent.button
                  "
                />
              </template>
              <img v-if="pkgBtnBg.length && pkgBtnBg[selectIndex]" :src="pkgBtnBg[selectIndex]" class="pkg-button" :class="pkgBtnClass">
              <div v-if="isAnimationBtn" class="pay-button-animation">
                <img :src="isAnimationBtn">
              </div>
              <div v-if="isCaLiangBtn" class="pay-button-caliang">
                <img :src="isCaLiangBtn">
              </div>
              <template v-if="isShowBtnCountDown">
                <div class="countdown-btn">
                  <div class="countdown-btn-text">{{ countdownBtnText }}</div>
                  <countdown
                    v-if="!isBtnCountDownFinish"
                    :end-time="new Date().getTime() + 1000 * (btnCountdownTime || 1) * 59"
                    ref="countdown"
                    @finish="handleBtnCountDownFinish"
                  >
                    <span
                      slot="process"
                      slot-scope="timeScop"
                      class="countdown"
                      :class="{'countdown1': btnCountdownTime > 1}"
                    >
                      <svg-icon
                        icon-class="countdown-clock"
                        class="countdown-icon"
                      />
                      <span v-if="btnCountdownTime > 1" class="countdown-m">{{ timeScop.timeObj.m }}:</span>
                      <span>{{ timeScop.timeObj.s }}</span>
                      <span v-if="!packagesContent.showCountdownH">:{{ String(milliseconds).padStart(2, '0') }}</span>
                    </span>
                  </countdown>
                </div>
              </template>
            </div>
            <div v-if="isShowFootbar && songItem.sno" class="play-song" @click="handleOrderNormal"></div>
          </div>
          <div v-if="propStyleVar.handUrl" class="hand" :class="{ 'hand-from-bottom': showConfigTitles }"><img :src="propStyleVar.handUrl"></div>
        </template>
        <!-- 演唱普通版 -->
        <p
          v-if="showOriginal && songItem.sno"
          class="order-song-area"
          @click="handleOrderNormal"
        ></p>
        <!-- 演唱普通版 - end -->
        <div
          v-if="(showAgreement || showAgreement1 || showAgreement2 || topAgreement) && !bottomAgreement && !showAgreementText"
          class="agreement"
          :class="[
            {
              'top' : showAgreement1,
              'bottom' : showAgreement2,
              'top-top' : topAgreement,
              'toast-top' : showTopAgreement,
            },
            agreementClassName,
          ]"
          @click.self="handleClickAgreement"
        ></div>
        <div v-if="bottomAgreement" class="agreement-bottom" @click.self="handleClickAgreement">开通即接受《用户服务协议》</div>
        <div v-if="showAgreementText" class="agreement-section" @click.self="handleClickAgreement">
          <!-- <svg-icon
            icon-class="agreement-select"
            class="agreement-checkbox"
            :style="`color:${propStyleVar.agreementTextColor};`"
          /> -->
          开通即接受
          <div class="agreement-link" @click.self="handleClickAgreement">《用户服务协议》</div>
        </div>
        <div v-if="hideClose" @click="handleClickClose(true)" class="close-area"></div>
      </div>
      <div
        v-show="!hideClose"
        class="top-close"
        :class="[closeClassName, newCloseType && 'top-right-close']"
        @click="handleClickClose(true)"
      >
        <img
          v-if="newCloseType"
          :src="newCloseImg"
        />
        <img v-else src="../../../imgs/icon/toast-top-close.png" />
      </div>
    </div>
  </div>
</template>
<script>
import { utils } from '@/libs/interfaces';
import { reportPay } from '@/libs/utils/log/log';
import mixinOldVip from '@/mixins/vip-toast-test';
import store from '@/store'
import AddOneYuan from '@/components/app/addOneYuan'
import GiveFriend from '@/components/app/giveFriend'
import get from 'lodash/get'
import {
  FirstHomeToastDiscount, VIP_PACKAGES, MonthFirstSkuToast, newRole4MonthSkuDiscount7, newRole4MonthFirstSkuToast7, newRole4MonthSkuDiscount90, newRole4MonthFirstSkuToast90, newRole4DayCardConfig, newRole4DayCardFirstToast, ROLE4_UNIFIED_CONFIG, HS_STB_TP_CLUB, buildRole4HsStbOldvipKaipingCcPatch,
} from '@/libs/utils/consts'
import wx from 'weixin-js-sdk'
import cloneDeep from 'lodash/cloneDeep'
import { APOLLO_VIP_SONGS_PAY_TP } from '@/libs/utils/apollo-playlist'

/** 已含 TOP-VIPSongs-yzs-role2（含 AB 前缀 A/B）时不再拼 _role2 */
function hasApolloTopVipPageTp(pageTp) {
  if (!pageTp) return false
  return pageTp === APOLLO_VIP_SONGS_PAY_TP || pageTp.endsWith(APOLLO_VIP_SONGS_PAY_TP)
}

const ONEDAY_TIMESTAMP = 24 * 60 * 60 * 1000;
export default {
  name: 'RaiseNewPayment',
  mixins: [mixinOldVip],
  data() {
    return {
      showUserAvatar: false,
      userAvatarClass: '',
      showCrown: false, // 头像皇冠
      showRole4Title: false,

      showTopImg: '', // 是否显示顶部图片
      showTopText: '', // 是否显示顶部文字
      showTopAnimation: '', // 是否显示顶部动画
      // VIP专享热歌限定
      showHotSong: false,
      hotsongSwiperOption: {
        preventLinksPropagation: false,
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        direction: 'vertical',
        duration: 0,
        observer: true,
        speed: 1500,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: 'column',
      },
      hotsongSwiperData: [],
      // VIP专享热歌限定 ---- end
      show: false,
      contentBg: '',
      packages: VIP_PACKAGES,
      selectIndex: 0,
      swiperData: [],
      swiperOption: {
        pagination: { el: '.swiper-pagination' },
        preventLinksPropagation: false,
        watchOverflow: true,
        loop: true,
        autoplay: { disableOnInteraction: false },
      },
      page_tp: '',
      className: '',
      avatarTextClass: '',
      closeClassName: '',
      agreementClassName: '', // 协议热区自定义样式类名
      scene: '', // 仅针对音译特殊打点
      enterTime: 0,
      // 特殊的支付pkg_id，与isDiscount绑定。如果isDiscount===true，memberIdArr才会生效；如果isDiscount===false，就走默认的pkg_id [2,1,4]
      memberIdArr: [78, 76, 50],
      memberIdArr1: [96, 95, 94],
      memberIdDayArr: [106, 121, 4], // 2.9/12.9/21.9
      giveFriendPackages: null,
      price: null,
      propStyleVar: {
        plusSvg: 'plus',
      },
      isDiscount: false,
      packageLogo: false,
      bottomBar: false,
      songItem: {},
      isShowAddOnePackages: false,
      isShowGiveFriend: false,
      showOriginal: false,
      chooseAddOneYuan: false,
      AddOneYuanIds: [115, 114, 113],
      isChooseAddOneYuan: false,
      isChooseGiveFriend: false,
      hidePlus: false, // 是否隐藏「plus」icon
      hideIconApp: false, // 是否隐藏「app」icon
      hideTip: false, // 是否隐藏「联合VIP优惠」
      packagesContent: {}, // 特殊定制的套餐信息，
      giveFriendConfig: null,
      ignoreDialogScene: [
        '1年plus',
        '3个月',
      ],
      // 示例：
      // packagesContent: {
      //   current: ['¥<span>9.9</span>', '¥<span>25.9</span>', '¥<span>29.9</span>'],
      //   origin: ['¥9.9', '¥29.9', '¥59.9'],
      //   button: 'https://qncweb-back1.ktvsky.com/20211116/vadd/e2037ecc386774d6e29d18e1523847b0.png',
      //   plusButton: 'https://qncweb-back1.ktvsky.com/20211116/vadd/6fe2f29af1b02183ac609b074fe40da0.png',
      //   tagContent: ['', '限时8折', '限时5折 数量有限'],
      // },
      showTip: false,
      showPackageTopHot: false,
      packageTopHotIndex: 1,
      packageTopHotPayEnter: '',
      isAnimationBtn: '', // 是否显示动画按钮,按钮的图片
      isCaLiangBtn: '', // 是否显示 擦亮动画 按钮,按钮的图片
      isShowFootbar: false,
      isbuyVipCallback: false,
      callback: null,
      cancelcallback: null,
      cancelCloseCallBack: null,
      clickCloseCallback: null,
      buyVipCallback: null,
      isDayVip: false,
      packagesStyle: '',
      packagesliStyle: '',
      iscloseCallback: false,
      showOrderRoll: false,
      hideLine: false, // 隐藏第一栏的删除线
      showFloatAdConfigure: {
        isShow: [false, false, false],
      },
      bottomIconApp: [true, true, true],
      packageIds: [],
      mikeurl: '',
      isMonthDiscount: false,
      isMonthFirstDiscount: false,
      discountIndex: null,
      discountDayFee: '',
      isShowDiscountDayFee: false, // 是否显示优惠小时费
      closeToast: false,
      pkgsDes: [],
      pkgBtnClass: '',
      pkgBtnBg: [],
      ButtonTip: [],
      excludesId: null,
      isShowTopClose: false, // 关闭按钮显示在右上方
      customerBtn: {},
      isShowCloseBtn: false, // 是否显示残忍拒绝按钮
      showAgreement: false, // 用户协议入口
      showAgreement1: false,
      showAgreement2: false,
      topAgreement: false, // 协议在套餐上面
      bottomAgreement: false, // 协议在弹窗下面
      showTopAgreement: false, // 协议在弹窗上方
      showAgreementText: false, // 协议用文案在弹窗下方
      hideClose: false,
      limitClose: false, // 是否限制点击其他区域可关闭弹窗
      newCloseType: false, // 位置处于右上角
      newCloseImg: 'https://qncweb-back1.ktvsky.com/20230602/other/c80fe11d35b1a3ffd913691288826613.png', // 右上角关闭按钮图片
      isBottomType: false, // 弹窗底部上拉样式
      isCloseAnimation: false, // 是否展示下拉关闭动画
      timer: null,
      milliseconds: 99,
      showThreeTiersPayment: true,
      isBottomPosition: false,
      originPkgs: null,
      originPkgsGiveVip: null,
      isShowTextCountDown: false, // 是否展示按钮上方文案倒计时
      isShowTextCountDownBig: false, // 是否展示按钮上方文案倒计时,倒计时放大
      countdownPrefixText: '', // 倒计时前缀文案（自定义配置）
      countdownSuffixText: '', // 倒计时后缀文案
      isShowBtnCountDown: false, // 是否显示按钮倒计时
      isBtnCountDownFinish: false, // 按钮倒计时是否结束
      btnCountdownTime: 1, // 按钮倒计时时间（分钟），默认1分钟
      noShowCountDown: false, // 不展示倒计时
      isShowCountDownNoFinish: false, // 是否仅展示倒计时，结束不恢复原价
      isShowTopTap: '', // 是否展示顶部标签
      showUserAvatarText: '', // 是否展示弹窗顶部头像+文案
      shouldSwap: false, // 文字倒计时是否在赠好友上方
      countdownBtnText: '立即开通', // 倒计时按钮文案
      showTopUserCount: false, // 是否显示顶部用户数文案
      currentUserCount: 3260, // 当前显示的用户数
      userCountTimer: null, // 用户数更新定时器
      isScrolling: false,
      isShowHongBao: false, // 倒计时后面是否显示红包图标
    };
  },
  computed: {
    user_img() {
      return store.state.user_img || 'https://qncweb-back1.ktvsky.com/20221021/other/85220abb50ca0c8ff17e1b4045d563ff.png';
    },
    user_name() {
      return store.state.user_name || '尊敬的用户';
    },
    /**
     * 处理用户头像文本显示
     * 当父组件传入特殊值 'USERNAME' 时显示用户名称，否则显示原文案
     * @returns {string} 处理后的显示文本
     */
    processedUserAvatarText() {
      if (!this.showUserAvatarText) return '';
      // 当传入特殊值 'USERNAME' 时，显示用户名称
      if (this.showUserAvatarText === 'USERNAME') {
        return this.user_name;
      }
      // 否则显示原文案
      return this.showUserAvatarText;
    },
    packageTopHotStyle() {
      const cfg = (this.propStyleVar && this.propStyleVar.packageTopHot) || {};
      return {
        left: cfg.left || '8vw',
        right: cfg.right || '8vw',
        bottom: cfg.bottom || '66vw',
        height: cfg.height || '26vw',
      };
    },
    showConfigTitles() {
      return Boolean(this.effectiveMainTitle || this.effectiveSubTitle);
    },
    isSingerDetailScene() {
      if (!this.page_tp) return false
      const tp = this.page_tp
      return tp.includes('singer_detail')
        || tp.includes('geshen_topsSong')
        || /geshen.*sort_bottom/.test(tp)
    },
    isSingerGeshenScene() {
      return this.isSingerDetailScene
        && this.songItem.music_name
        && (this.role === 'role4' || this.role === 'role5')
    },
    effectiveMainTitle() {
      if (this.isSingerGeshenScene) {
        return `想唱《${this.songItem.music_name}》？`
      }
      return this.propStyleVar?.mainTitle || this.mainTitle || '';
    },
    effectiveSubTitle() {
      if (this.isSingerGeshenScene) {
        return '开通即可高质点唱'
      }
      return this.propStyleVar?.subTitle || this.subTitle || '';
    },
    mainTitleStyle() {
      const color = this.propStyleVar?.mainTitleColor || this.mainTitleColor || '#FFFFFF';
      const fontSize = this.propStyleVar?.mainTitleFontSize ?? this.mainTitleFontSize;
      return {
        ...this.toTextPaintStyle(color),
        fontSize: typeof fontSize === 'number' ? this.toAdaptiveFontSize(fontSize) : '',
      }
    },
    subTitleStyle() {
      const color = this.propStyleVar?.subTitleColor || this.subTitleColor || '#FFFFFF';
      const fontSize = this.propStyleVar?.subTitleFontSize ?? this.subTitleFontSize;
      return {
        ...this.toTextPaintStyle(color),
        fontSize: typeof fontSize === 'number' ? this.toAdaptiveFontSize(fontSize) : '',
      }
    },
    role() {
      return store.state.role;
    },
    is_vip() {
      return store.state.is_vip;
    },
    vip_endtime() {
      return store.state.vip_endtime;
    },
    expireDays() {
      return Math.ceil((new Date().getTime() - new Date(this.vip_endtime.replace(/-/g, '/'))) / ONEDAY_TIMESTAMP);
    },

    contentStyle() {
      return {
        backgroundImage: `url(${this.contentBg})`,
      };
    },
    getLogoUrl() {
      return this.bottomBar ? 'https://qncweb-back1.ktvsky.com/20210721/vadd/c2d6824610e9867ef9c9c7e2cda010c1.png' : 'https://qncweb-back1.ktvsky.com/20210707/vadd/1c70431cbbed36158abf02029fa5b944.png';
    },
    styleVar() {
      return {
        '--raise-wight': this.propStyleVar.raiseWight || '81.333vw', // 弹窗宽度
        '--raise-padding': this.propStyleVar.raisePadding || 0, // 弹窗内底部边框
        '--package-bg': this.propStyleVar.packageBg, // vip套餐未选中背景
        '--package-bg-selected': this.propStyleVar.packageBgSelected, // vip套餐选中背景颜色
        '--tip-bg': this.propStyleVar.tipBg, // .tip的背景颜色
        '--tip-color': this.propStyleVar.tipColor || '#fff', // .tip的文字颜色
        '--plus-color': this.propStyleVar.plusColor, // 图标plus的svg的背景颜色
        '--tag-bg': this.propStyleVar.tagBg || '#F2483D', // .tag的背景颜色
        '--tag-bg-selected': this.propStyleVar.tagBgSelected || this.propStyleVar.tagBg, // .tag选中的背景颜色
        '--tag-top': this.propStyleVar.tagTop || '-2vw', // .tag的位置
        '--tag-left': this.propStyleVar.tagLeft || '-0.267vw', // .tag的位置
        '--tag-size': this.propStyleVar.tagSize || '2.667vw', // .tag的字体大小
        '--tag-padding': this.propStyleVar.tagPadding || '0 1.467vw', // tag的左右padding值
        '--tag-color': this.propStyleVar.tagColor || '#f8f8fa', // .tag的颜色
        '--tag-color-selected': this.propStyleVar.tagColorSelected || this.propStyleVar.tagColor || '#f8f8fa', // .tag选中的颜色
        '--tag-radius': this.propStyleVar.tagRadius || '10px 0 10px 0', // .tag的圆角
        '--tag-radius-new': this.propStyleVar.tagRadiusNew || '20px 20px 20px 0', // .tag的圆角
        '--tag-line-height': this.propStyleVar.tagLineHeight || '5.333vw', // .tag的字体高度
        '--tag-bold': this.propStyleVar.tagBold || 'bold', // .tag的字体加粗
        '--swiper-bullet-bg': this.propStyleVar.swiperBulletBg,
        '--swiper-bullet-active-bg': this.propStyleVar.swiperBulletActiveBg,
        '--button-height': `${this.propStyleVar.buttonHeight}`, // 底部按钮高度（需要转换成vw）
        '--button-margin': this.propStyleVar.buttonMargin || 0, // 底部按钮边距
        '--button-vip-height': this.propStyleVar.buttonVipHeight || '9.5vw', // 底部「了解详情」
        '--color-des': this.propStyleVar.fontColor.normal[0], // vip套餐第一行文字颜色
        '--color-month': this.propStyleVar.fontColor.normal[1], // vip套餐第二行文字颜色
        '--color-price': this.propStyleVar.fontColor.normal[2], // vip套餐第三行文字颜色
        '--color-des-selected': this.propStyleVar.fontColor.selected[0], // vip套餐第一行选中文字颜色
        '--color-month-selected': this.propStyleVar.fontColor.selected[1], // vip套餐第二行选中文字颜色
        '--color-price-selected': this.propStyleVar.fontColor.selected[2], // vip套餐第三行选中文字颜色
        '--color-span': this.propStyleVar.monthColorSpan || this.propStyleVar.fontColor.normal[1],
        '--color-span-selected': this.propStyleVar.monthColorSpan || this.propStyleVar.fontColor.selected[1],
        '--font-weight': this.propStyleVar.fontWeight || '500', // vip套餐文字加粗
        '--color-border': this.propStyleVar.borderColor && this.propStyleVar.borderColor.normal, // 边框颜色
        '--color-border-selected': this.propStyleVar.borderColor && this.propStyleVar.borderColor.selected, // 边框选中颜色
        '--border-width': this.propStyleVar.borderWidth?.normal || '.267vw',
        '--border-width-selected': this.propStyleVar.borderWidth?.selected || '.267vw',
        '--color-logo-bg': this.propStyleVar.logoBg && this.propStyleVar.logoBg.normal, // logo背景颜色
        '--color-logo-bg-selected': this.propStyleVar.logoBg && this.propStyleVar.logoBg.selected, // logo选中背景颜色
        '--price-text-decoration': get(this.propStyleVar, 'price.textDecoration', 'initial'), // vip套餐第三行文字样式
        '--close-right': this.propStyleVar.closeRight || '-2.667vw', // 关闭按钮右边距
        '--time-tip-bg': this.propStyleVar.timeTipBg || '#f8341a', // 倒计时背景颜色
        '--time-tip-color': this.propStyleVar.timeTipColor || '#ffffff', // 倒计时文字颜色
        '--countdown-height': this.propStyleVar.countdownHeight || '12vw', // 倒计时按钮高度
        '--countdown-margin': this.propStyleVar.countdownMargin || '2.667vw auto 5.333vw', // 倒计时按钮边距
        '--countdown-bg': this.propStyleVar.countdownBg || 'linear-gradient(90deg, #FF6B00 0%, #FFBB0B 100%)', // 倒计时背景颜色
        '--countdown-color': this.propStyleVar.countdownColor || '#ffffff', // 倒计时文字颜色
        '--bottom-tip-radius': this.propStyleVar.bottomTipRadius || '0 0 .667vw .667vw', // 套餐底部圆角
        '--top-agreement-top': this.propStyleVar.topAgreementTop || '-13.333vw', // 协议在弹窗上方
        '--text-countdown-color': this.propStyleVar.textCountdownColor || '#FF1232', // 倒计时文字颜色
        // 头像相关配置
        '--crown-width': this.propStyleVar.crownWidth || '8.267vw', // 默认62px转换
        '--crown-height': this.propStyleVar.crownHeight || '8.267vw',
        '--avatar-frame-width': this.propStyleVar.avatarFrameWidth || '13.333vw', // 默认100px转换
        '--avatar-frame-height': this.propStyleVar.avatarFrameHeight || '13.333vw',
        '--crown-url': this.propStyleVar.crownUrl || 'https://qncweb.ktvsky.com/20250423/vadd/bbb86fa5fd27310e3dd11d2f57976973.png',
        '--avatar-frame-bg': `url(${this.propStyleVar.avatarFrameUrl || 'https://qncweb-back1.ktvsky.com/20231212/other/02df3607992e78a5dae083aeb3a75ce4.png'})`,
        '--user-img-width': this.propStyleVar.userImgWidth || 'var(--avatar-frame-width)',
        '--user-img-height': this.propStyleVar.userImgHeight || 'var(--avatar-frame-height)',
        '--hand-top': this.propStyleVar.handTop || '46vw',
        '--agreement-text-color': this.propStyleVar.agreementTextColor || 'rgba(0, 0, 0, 0.4)',
        '--tip-bottom-radius': this.propStyleVar.tipBottomRadius || '0 0 .2.4vw 2.4vw', // 套餐底部圆角
      };
    },
  },
  methods: {
    toTextPaintStyle(paint) {
      const raw = typeof paint === 'string' ? paint.trim() : ''
      const cleaned = raw.endsWith(';') ? raw.slice(0, -1).trim() : raw
      if (!cleaned) return { color: '' }
      const lower = cleaned.toLowerCase()
      const isGradient = lower.includes('linear-gradient(') || lower.includes('radial-gradient(') || lower.includes('conic-gradient(')
      if (!isGradient) return { color: cleaned }
      return {
        backgroundImage: cleaned,
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent',
        WebkitTextFillColor: 'transparent',
      }
    },
    toAdaptiveFontSize(px, designWidth = 375) {
      const n = Number(px)
      if (!Number.isFinite(n) || n <= 0) return ''
      // 将后台配置的 px 转为自适应：中间用 vw，最大不超过原 px，最小给 0.75 倍兜底
      const vw = (n / designWidth) * 100
      const minPx = Math.max(10, Math.round(n * 0.75))
      return `clamp(${minPx}px, ${vw.toFixed(3)}vw, ${n}px)`
    },
    handleBtnCountDownFinish() {
      this.isBtnCountDownFinish = true;
      clearInterval(this.timer)
      if (this.is_vip) {
        this.packagesContent.showTag = false;
        this.packagesContent.tagContent = ['', '', '']; // 隐藏标签
      }
    },
    handleClickContent() {
      if (this.showThreeTiersPayment) return
      this.payVip()
    },
    // 开屏弹窗：减5元红包: https://m2miovoqda.feishu.cn/wiki/wikcnJRn2I88HmxyrkPqBwbOQTf
    // 倒计时结束后重置套餐
    handleCountDownFinish() {
      this.isMonthDiscount = false;
      clearInterval(this.timer);
      if (this.is_vip) {
        this.packagesContent.showTag = false;
        this.packagesContent.tagContent = ['', '', '']; // 隐藏标签
        this.isShowDiscountDayFee = true;
      }
    },
    // VIP专享热歌限定
    getSongTypeIcon(type) {
      const { rankAttach } = store.state.config
      return rankAttach.find((item) => type === item.type) || {}
    },
    // 点击弹窗底部关闭按钮回调事件
    handleClickClose(isCloseBtn) {
      // 需求：https://m2miovoqda.feishu.cn/wiki/wikcnc4BbzPlFyauvgBO9HFWQDv
      if (!isCloseBtn && this.limitClose) return
      // 检查是否在同一天内关闭了多次弹窗
      let today = new Date();
      let todayDate = today.getDate();
      let lastCloseDate = parseInt(utils.cookie.getCookie('closeToastNumLastDay') || todayDate, 10);
      let closeCount = parseInt(utils.cookie.getCookie('closeToastNum') || 0, 10);

      if (todayDate === lastCloseDate) {
        closeCount += 1;
      } else {
        closeCount = 1;
      }
      utils.cookie.setCookie(closeCount, 1, 'closeToastNum');
      utils.cookie.setCookie(todayDate, 1, 'closeToastNumLastDay');
      // 底部上拉弹窗关闭下拉处理
      if (this.isBottomType) {
        this.isCloseAnimation = true
        setTimeout(() => {
          this.show = false;
          clearInterval(this.timer)
        }, 450)
      } else {
        this.show = false;
        clearInterval(this.timer)
      }
      store.commit('SET_ORDER_LIST', true)
      if (this.iscloseCallback) {
        this.closeCallback()
      }
      if (typeof this.clickCloseCallback === 'function') {
        this.clickCloseCallback()
      }
    },
    choosePackage(index) {
      this.selectIndex = index;
    },
    handlePackageTopHotClick() {
      this.selectIndex = this.packageTopHotIndex;
      this.payVip(this.packageTopHotPayEnter || null);
    },
    isTagHiddenByTopCountdown(index) {
      if (!this.packagesContent.countdownTtop) return false;
      if (this.isShowBtnCountDown || this.isShowTextCountDown || this.noShowCountDown) return false;
      let countdownIndex = null;
      if (this.packagesContent.countdownIndex != null) {
        countdownIndex = this.packagesContent.countdownIndex;
      } else if (this.isMonthDiscount) {
        countdownIndex = this.discountIndex;
      }
      return index === countdownIndex;
    },
    setTip(saveTip, index) {
      // eslint-disable-next-line
      return this.bottomIconApp[index] && this.packageLogo && index === 2 || this.bottomBar && index === 2 ? '超划算 省88.9元' : saveTip;
    },
    handleClickAgreement() {
      this.event.$store.commit('SAVE_AGREE_SHOW', true)
      this.$sendLog({
        event_type: 'click',
        event_name: '用户协议',
        event_data: {
          name: '弹窗',
        },
      });
    },
    handleClickBuyButton() {
      const { is_72hour, is_vip } = store.state;
      if (this.page_tp.includes('homevipicon') && !is_72hour && is_vip) {
        this.$sendLog({
          event_type: 'show',
          event_name: '二次确认弹窗展示',
          event_data: {
            name: this.page_tp,
          },
        });
        this.$messageBox.confirm('您已成为VIP，确认续费吗？', '', {
          confirmButtonText: '确认支付', cancelButtonText: '取消支付',
        }).then(() => {
          this.$sendLog({
            event_type: 'click',
            event_name: '二次确认弹窗点击确认支付',
            event_data: {
              name: this.page_tp,
            },
          });
          this.payVip()
        }).catch(() => {
          this.$sendLog({
            event_type: 'click',
            event_name: '二次确认弹窗点击确认取消',
            event_data: {
              name: this.page_tp,
            },
          });
          this.$messageBox.close();
        });
        return
      }
      this.payVip()
    },
    payVip(fixedPayEnter) {
      let item = this.packages[this.selectIndex]
      let pay_enter = this.page_tp
      let pkgId = item.pkg_id
      // 开屏弹窗2：赠月卡测试
      if (this.packageIds[this.selectIndex]) {
        pkgId = this.packageIds[this.selectIndex]
      }
      // 一日体验会员
      if (this.isDayVip) {
        pkgId = this.memberIdDayArr[this.selectIndex]
      }
      // 减五元
      if (this.isDiscount) {
        pkgId = this.memberIdArr[this.selectIndex]
      }
      // 减三元
      if (this.isDiscount1) {
        pkgId = this.memberIdArr1[this.selectIndex]
      }
      let pay_fee = item.current_fee
      if (this.price) { // 调价
        pay_fee = this.price[this.selectIndex]
      }
      // 是否选择了加1元
      if (this.chooseAddOneYuan) {
        pay_enter = `${this.page_tp}_addone`
        pkgId = this.AddOneYuanIds[this.selectIndex]
      }
      if (this.isChooseGiveFriend) {
        let { presentVipPackages } = store.state;
        let config = this.giveFriendPackages || presentVipPackages;
        // role4用户使用ROLE4_UNIFIED_CONFIG中的dayCardGift配置
        if (this.role === 'role4') {
          // 找到日卡的索引（通常是days=1的包）
          const dayCardIndex = config.findIndex((pkg) => pkg.days === 1);
          if (dayCardIndex !== -1) {
            // 创建新的配置数组，避免修改原始数据
            config = [...config];
            config[dayCardIndex] = {
              ...config[dayCardIndex],
              ...ROLE4_UNIFIED_CONFIG.dayCardGift
            };
          }
        }

        item = config[this.selectIndex]
        // 当 page_tp 为以下值时不添加 _zs 后缀
        // 带_yzs标识的页面类型或特定页面类型不再添加_zs后缀
        const excludeZsSuffixPageTypes = ['ordered_banner'];
        pay_enter = (this.page_tp.includes('_yzs') || excludeZsSuffixPageTypes.includes(this.page_tp)) ? this.page_tp : `${this.page_tp}_zs`
        pkgId = item.pkg_id
        pay_fee = item.current_fee
        if (this.page_tp == 'homevipicon') {
          this.$sendLog({
            event_type: 'click',
            event_name: '首页icon点亮vip赠送好友点击',
          });
        }
      }
      // 添加判断,当是VIP用户时替换pkgId
      // if (store.state.is_vip && pkgId === 50) {
      //   pkgId = 38
      // }
      if (fixedPayEnter) {
        pay_enter = fixedPayEnter
      } else if (!hasApolloTopVipPageTp(pay_enter)) {
        pay_enter = `${pay_enter}_${this.role}`
      }
      reportPay({
        page_tp: pay_enter,
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
        tc_tp: pkgId,
      });
      if (this.statName) {
        this.event.$sendLog({
          event_type: 'click',
          event_name: this.statName,
          event_data: {
            name: this.chooseAddOneYuan ? `${item.desc}+【+1元】会员立即开通` : `开通${item.desc}会员按钮`,
          },
        });
      }
      store.commit('SET_ORDER_LIST', true)
      utils.util.buyVipPlus({
        memberId: pkgId,
        pay_fee,
        pay_enter,
        $this: this.event,
        vipSongInfo: this.songItem,
        isChooseGiveFriend: this.isChooseGiveFriend,
        closeToast: this.closeToast,
        callback: () => {
          this.show = false;
          this.playOpenVip = false;
          this.event.$store.commit('SAVE_IS_VIP');
          if (!this.ignoreDialogScene.includes(item.desc)) {
            this.event.$sendLog({
              event_type: 'show',
              event_name: `${item.desc}会员开通成功弹窗`,
            });
          }
          if (this.isbuyVipCallback) {
            this.buyVipCallback()
          }
          if (typeof this.callback === 'function') {
            this.callback()
          }
          if (this.songItem && Object.keys(this.songItem).length > 0) { // 判断songItem不为{}
            this.event.orderSong('1', this.songItem);
          }
        },
        cancelcallback: () => {
          if (this.page_tp == 'kaiping_moresong') {
            this.$sendLog({
              event_type: 'click',
              event_name: '"取消支付"点击',
              event_data: {
                name: '首页-首个开屏弹窗',
              },
            })
          }
          if (typeof this.cancelcallback === 'function') {
            this.cancelcallback()
          }
        },
        cancelCloseCallBack: () => {
          if (typeof this.cancelCloseCallBack === 'function') {
            this.cancelCloseCallBack()
          }
        },
        giveFriendSuccess: () => {
          if (this.songItem && Object.keys(this.songItem).length > 0 && !this.isChooseGiveFriend) {
            this.event.orderSong('1', this.songItem);
          }
        },
      });
    },
    handlePageUnload() {
      reportPay({
        page_tp: this.page_tp,
        active_tp: 1, // 用户行为：0：点击 ;1：停留
        stay_time: Date.now() - this.enterTime, // 停留时间(单位：毫秒)
      });
    },
    handleOrderNormal() {
      this.event.$sendLog({
        event_type: 'click',
        event_name: `${this.scene}点击演唱${this.songItem.type}普通版按钮`,
        event_data: {
          tp: this.page_tp,
          route: this.event.$route.name,
        },
      });
      this.event.orderSong('0', this.songItem);
      this.show = false;
      store.commit('SET_ORDER_LIST', true)
    },
    slectedAddOneYuan() {
      this.isChooseAddOneYuan = !this.isChooseAddOneYuan
      this.chooseAddOneYuan = this.isChooseAddOneYuan
    },
    presentVipClick() {
      this.isChooseGiveFriend = !this.isChooseGiveFriend
    },
    handleClickTip() {
      this.event.$sendLog({
        event_type: 'click',
        event_name: 'VIP抢鲜唱说明弹窗说明按钮点击',
      });
      this.event.$toast('<p>本服务为高级音效</p><p>开通VIP抢鲜体验</p>')
    },
    handleClickCloseButton() {
      if (this.event.$route.query.fromType === '90houExpired') {
        wx.closeWindow()
      }
      this.show = false
    },
    initVipPrice() {
      if (!this.isMonthDiscount || !this.is_vip) return;
      // 找到3个月套餐的索引
      const monthIndex = this.packages?.findIndex((pkg) => pkg.pkg_id === 50);
      if (monthIndex === -1) return;
      // 克隆并更新packagesContent
      const clonedPackagesContent = cloneDeep(this.packagesContent);
      if (clonedPackagesContent.current) {
        clonedPackagesContent.current[monthIndex] = '¥<span>0.04</span>/小时';
      }
      if (clonedPackagesContent.origin) {
        clonedPackagesContent.origin[monthIndex] = '¥79.9';
      }
      this.packagesContent = clonedPackagesContent;
    },
    startUserCountAnimation() {
      this.userCountTimer = setInterval(() => {
        this.currentUserCount += 12;
      }, 3000);
    },
    updateRole4Packages() {
      if (this.role !== 'role4') return;
      const dayCardIndex = this.packages.findIndex((pkg) => pkg.days === 1);
      if (dayCardIndex === -1) return;
      const updatedPackages = [...this.packages];
      updatedPackages[dayCardIndex] = {
        ...updatedPackages[dayCardIndex],
        ...ROLE4_UNIFIED_CONFIG.dayCard
      };
      this.packages = updatedPackages;
    },

  },
  components: {
    AddOneYuan,
    GiveFriend,
  },
  watch: {
    /**
     * 监听 role 变化，当用户角色变为 role4 时更新日卡配置
     */
    role(newRole) {
      if (newRole === 'role4') {
        this.updateRole4Packages();
      }
    }
  },
  mounted() {
    const isRole4VipDay = this.role === 'role4' && utils.util.checkVipExpiredWithinDays({ $this: this, days: -7 });
    const isRole4VipDay90 = this.role === 'role4' && !utils.util.checkVipExpiredWithinDays({ $this: this, days: -90 });

    if (this.isMonthDiscount) {
      const customPackagesContent = this.packagesContent ? cloneDeep(this.packagesContent) : {};
      if (!this.isSpecialPackages) {
        const init = cloneDeep(FirstHomeToastDiscount);
        Object.assign(this, init);
      }

      const isRole4General = this.role === 'role4' // 所有role4用户

      if (this.isMonthFirstDiscount) {
        let discountConfig = MonthFirstSkuToast;
        if (isRole4VipDay) {
          discountConfig = newRole4MonthFirstSkuToast7;
        } else if (isRole4VipDay90) {
          discountConfig = newRole4MonthFirstSkuToast90;
        } else if (isRole4General) {
          discountConfig = newRole4DayCardFirstToast;
        }

        const init = cloneDeep(discountConfig);
        Object.assign(this, init);
      }
      if (isRole4VipDay && !this.isSpecialPackages) {
        const init = cloneDeep(newRole4MonthSkuDiscount7);
        Object.assign(this, init);
      } else if (isRole4VipDay90 && !this.isSpecialPackages) {
        const init = cloneDeep(newRole4MonthSkuDiscount90);
        Object.assign(this, init);
      } else if (isRole4General && !this.isSpecialPackages) {
        const init = cloneDeep(newRole4DayCardConfig);
        Object.assign(this, init);
      }
      switch (this.page_tp) {
        case 'kaiping_moresong':
           if (!this.isSpecialPackages) {
              this.packagesContent.tagContent = ['', '新客减5元', ''];
           }
           break;
        case 'orderzd_reduce5':
          this.packagesContent.tagContent = ['', '立减5元', ''];
          break;
        case 'search_tc_vip':
          this.packagesContent.tagContent = ['', '续费减5元', ''];
          break;
        case 'cloud_song_speed':
          this.packagesContent.tagContent = ['', this.role === 'role4' ? '老客减5元' : '新客减5元', ''];
          break;
        default:
          // 默认情况下不做任何操作
          break;
      }

      if (customPackagesContent && Object.keys(customPackagesContent).length > 0) {
        Object.assign(this.packagesContent, customPackagesContent);
      }

      if (this.tagContentNew) {
        this.packagesContent.tagContent = this.tagContentNew
      }
      if (isRole4VipDay && !this.isSpecialPackages) {
        this.packagesContent.tagContent = ['', '续费立省', ''];
        if (this.packagesContent.bottomTip == '立减5元') {
          this.packagesContent.bottomTip = '续费立省'
        }
      }

      if (isRole4VipDay && this.isMonthFirstDiscount) {
        this.packagesContent.tagContent = ['续费立省', '', ''];
      }

      if (isRole4VipDay90 && !this.isSpecialPackages) {
        this.packagesContent.tagContent = ['', '立减6元', ''];
        if (this.packagesContent.bottomTip == '立减5元') {
          this.packagesContent.bottomTip = '立减6元'
        }
      }

      if (isRole4VipDay90 && this.isMonthFirstDiscount) {
        this.packagesContent.tagContent = ['立减6元', '', ''];
      }
      if (isRole4General && !isRole4VipDay && !isRole4VipDay90 && !this.isSpecialPackages) {
        this.packagesContent.tagContent = ['', '续费立省', ''];
        if (this.packagesContent.bottomTip == '立减5元') {
          this.packagesContent.bottomTip = '续费立省'
        }
      }

      if (isRole4General && !isRole4VipDay && !isRole4VipDay90 && this.isMonthFirstDiscount) {
        this.packagesContent.tagContent = ['续费立省', '', ''];
      }

      if (this.tagContentVipNew) {
        this.packagesContent.tagContent = this.tagContentVipNew
      }

      this.timer = setInterval(() => {
        this.milliseconds = (this.milliseconds < 0) ? 99 : this.milliseconds - 1;
      }, 10);
    } else if (this.isShowBtnCountDown) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.milliseconds = (this.milliseconds < 0) ? 99 : this.milliseconds - 1;
      }, 10);
    } else if (this.isShowTextCountDown) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.milliseconds = (this.milliseconds < 0) ? 99 : this.milliseconds - 1;
      }, 10);
    }
    const stbTpNorm = String(store.state.stb_tp || '').toLowerCase();
    if (this.page_tp === 'oldvip_kaiping_cc' && stbTpNorm === HS_STB_TP_CLUB && this.role === 'role4') {
      const withFirstMonthDiscount = this.kaipingCcFirstMonthDiscount !== false;
      const hsPatch = buildRole4HsStbOldvipKaipingCcPatch(
        isRole4VipDay,
        isRole4VipDay90,
        withFirstMonthDiscount,
      );
      Object.assign(this, hsPatch);
    }

    if (!store.state.intervalShowOrderList) {
      store.commit('SET_ORDER_LIST', false)
    }
    this.enterTime = Date.now();
    window.addEventListener('beforeunload', this.handlePageUnload);
    reportPay({
      page_tp: hasApolloTopVipPageTp(this.page_tp) ? this.page_tp : `${this.page_tp}_${this.role}`,
      active_tp: 3, // 用户行为：0：点击 ;1：停留
    });
    if (!store.state.isSupportInteract && this.swiperData.length) {
      this.swiperData = [
        'https://qncweb-back1.ktvsky.com/20210616/vadd/f35f73a4f2eb05e376fcb2ce43ad1715.png',
      ]
    }
    if (this.showTopUserCount) {
      this.startUserCountAnimation();
    }
    this.updateRole4Packages();
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handlePageUnload);
    clearInterval(this.timer);
    if (this.$refs.countdown) {
      this.$refs.countdown.stop();
    }
    if (this.userCountTimer) {
      clearInterval(this.userCountTimer);
    }
  },
};
</script>
<style lang="scss" scoped>
.banner {
  height: 54px;
  width: 358px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 118px;
}
// 全局弹窗
.raise-box-wrapper {
  @include background_color('mask-background');
  position: fixed;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.light-bg {
    background: rgba(0, 0, 0, 0.6)!important;
  }
  // position: relative;
}
.raise-box-top {
  position: absolute;
  top: -598px;
  left: 20px;
  width: 710px;
  height: 710px;
}
.raise-box-top-text {
  position: absolute;
  top: -80px;
  width: 750px;
  text-align: center;
  font-size: 38px;
  color: rgba($color: #ffffff, $alpha: 0.8);
}
.raise-box-top-animation {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  height: 66px;
  display: flex;
  justify-content: center;
  z-index: 100;

  img {
    width: 402px;
    height: 66px;

    &.breathing {
      animation: breaths 0.6s ease-in-out infinite;
    }
  }
}

@keyframes breaths {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.raise-box-content {
  width: var(--raise-wight);
  position: relative;
  .package-top-hot {
    position: absolute;
    z-index: 10;
  }
  .content-bg {
    width: var(--raise-wight);
    height: auto;
    position: relative;
    .nickname {
      position: absolute;
      height: 40px;
      overflow: hidden;
      color: #245DF1;
      font-size: 32px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 10px;
      z-index: 20;
      display: flex;
      span {
        @include rowHide(1);
        max-width: 180px;
      }
    }
    .tip-area {
      position: absolute;
      z-index: 10;
      width: 75px;
      height: 45px;
      left: 30px;
      top: 15px;
    }
  }

  .user {
    position: absolute;
    top: -54px;
    width: 100%;
    z-index: 10;
    .avatar {
      position: relative;
      width: 88px;
      height: 98px;
      margin: 0 auto;
    }
    .user-img {
      display: block;
      width: 88px;
      height: 88px;
      border: 4px solid #9A7959;
      border-radius: 44px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
    .user-level {
      width: 78px;
      height: 26px;
      position: absolute;
      left: 5px;
      bottom: 0px;
    }
    .user-name {
      font-size: 22px;
      color: #C19976;
      text-align: center;
      margin-top: 4px;
    }
  }
  .main-content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 2;
    padding: var(--raise-padding);
    .config-title-area {
      width: 100%;
      z-index: 90;
      text-align: center;
      pointer-events: none;
      padding: 0 24px;
      box-sizing: border-box;
      margin-bottom: 50px;
    }
    .config-main-title {
      font-weight: 600;
      line-height: 1.25;
      @include rowHide(2);
    }
    .config-sub-title {
      margin-top: 6px;
      font-weight: 400;
      line-height: 1.25;
      @include rowHide(2);
      opacity: 0.95;
    }
  }
}
.close {
  width: 74px;
  margin: 30px auto 0;
}
.top-close {
  width: 54px;
  position: absolute;
  right: var(--close-right);
  top: -74px;
}
.top-right-close{
  position: fixed;
  top: 44px;
  right: 20px;
}
.top-right-close-new {
  position: fixed;
  top: 100px;
  right: 20px;
}
.top-left-close {
  position: fixed;
  top: 100px;
  left: 20px;
}
.top-right-close-new1 {
  position: fixed;
  top: 100px;
  right: 60px;
}
.top-right-close-top {
  position: fixed;
  top: 0px;
  right: 0px;
}
.top-right-close-singer {
  position: fixed;
  top: 160px;
  right: 80px;
}
.vip-packages {
  width: 750px;
  height: 832px;
  padding-bottom: 20px;
  margin: 0 auto;
  background-size: 100% 100%;
  position: relative;
}
.packages-ul {
  display: flex;
  justify-content: space-between;
  margin: 0px 40px;
  text-align: center;
  height: 216px;
  li {
    position: relative;
    width: 168px;
    height: 216px;
    background: var(--package-bg);
    background-size: 100% 100%;
    border-radius: 10px;
    border: var(--border-width) solid var(--color-border);
  }
  .desc {
    color: var(--color-des);
  }
  .month-price {
    color: var(--color-month);
  }
  .price {
    color: var(--color-price);
    text-decoration: var(--price-text-decoration);
    img {
      width: 144px;
      margin: 13px auto 0;
    }
    ::v-deep b {
      font-weight: normal;
      color: #f2483d;
    }
    ::v-deep i {
      font-style: initial;
      text-decoration: line-through;
      margin-left: 5px;
    }
  }
  .selected {
    background: var(--package-bg-selected);
    background-size: 100% 100%;
    border: var(--border-width-selected) solid var(--color-border-selected);
    .desc {
      color: var(--color-des-selected);
    }
    .month-price {
      color: var(--color-month-selected);
      ::v-deep span {
        color: var(--color-span-selected);
      }
    }
    .price {
      color: var(--color-price-selected);
    }
    .tag {
      position: absolute;
      left:calc(0px - var(--border-width-selected));
      top: var(--tag-top);
    }
  }
  .item-plus {
    .month-price {
      margin-top: -8px;
    }
  }
  .tag {
    position: absolute;
    left: -2px;
    top: var(--tag-top);
    font-size: 20px;
    font-weight: var(--tag-bold);
    color: var(--tag-color);
    img {
      width: auto;
      height: 30px;
    }
    span {
      display: inline-block;
      background: var(--tag-bg);
      padding: var(--tag-padding);
      line-height: 30px;
      border-radius: var(--tag-radius);
      white-space: nowrap;
    }
  }
  .top-tap {
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    border-radius: 5px 5px 0 0;
    font-size: 20px;
    background: var(--tag-bg);
    color: var(--tag-color);
  }
  .desc {
    position: relative;
    margin-top: 36px;
    font-size: 26px;
    font-weight: 500;
    font-weight: bold;
    display: inline-block;
    .icon-plus {
      position: absolute;
      width: 44px;
      height: 100%;
      top: -10px;
      right: -45px;
      color: var(--plus-color);
    }
    .icon-img-plus {
      position: absolute;
      width: 44px;
      height: 20px;
      top: 0px;
      right: -50px;
    }
  }
  .month-price {
    margin-top: 10px;
    font-size: 20px;
    font-weight: 400;
    ::v-deep p {
      font-size: 20px;
    }
    ::v-deep span {
      font-size: 36px;
      padding: 0 6px;
      font-weight: var(--font-weight);
      color: var(--color-span);
    }
  }
  .price {
    width: 100%;
    font-size: 20px;
    font-weight: 400;
    position: absolute;
    bottom: 35px;
    left: 0;
  }
  .tip {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 30px;
    line-height: 30px;
    background: var(--time-tip-bg);
    font-size: 18px;
    font-weight: bold;
    color: var(--time-tip-color);
    border-radius: 0 0 5px 5px;
    .countdown span {
      display: inline-block;
      width: 30px;
      font-feature-settings: "tnum";
    }
  }
  .topTip {
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    border-radius: 5px 5px 0 0;
  }
  .bottom-tip {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    border-radius: var(--bottom-tip-radius);
    background: #ff0000;
  }
  .icon-app {
    position: absolute;
    top: 120px;
    left: 50%;
    margin-left: -45px;
    width: 90px;
  }
}
.tip1{
  .countdown {
    font-weight: normal;
    font-size: 16px;
  }
  .countdown span {
    margin-left: -4px;
  }
}
.hongbao-tip {
  text-align: left;
  .hongbao-icon {
    position: absolute;
    top: -16px;
    right: -16px;
    width: 50px;
  }
}
.text_countdown {
  width: 100%;
  height: 60px;
  color: var(--text-countdown-color);
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  margin: 40px 0 6px;
  .countdown span {
    display: inline-block;
    text-align: initial;
    width: 66px;
    font-feature-settings: "tnum";
  }
}
.text_countdown_big {
  width: 100%;
  height: 60px;
  line-height: 60px;
  color: #FF1232;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  margin: 30px 0 6px;
  .countdown span {
    display: inline-block;
    width: 110px;
    text-align: initial;
    font-size: 55px;
    font-weight: bold;
    font-feature-settings: "tnum";
  }
}
.text_countdown1 {
  margin-top: 10px;
  line-height: 60px;
}
.packages-ul1 {
   display: flex;
   justify-content: space-between;
   margin: 0px 40px;
   height: 236px;
   li {
     width: 188px;
     height: 236px;
   }
   .desc {
     font-size: 30px;
   }
   .month-price {
     margin-top: 10px;
     font-size: 22px;
     ::v-deep span {
       font-size: 38px;
     }
   }
   .price {
     position: absolute;
     bottom: 45px;
     left: 0;
   }
   .tag {
     position: absolute;
     left: 0;
     top: -12px;
     font-size: 20px;
     span {
       line-height: 35px;
       border-radius: 12px 0px 12px 0px;
     }
   }
   .tip {
     height: 40px;
     line-height: 40px;
     font-size: 22px;
   }
 }
.pay-button {
  width: 100%;
  height: var(--button-height);
  position: relative;
  margin: var(--button-margin);
  .pay-button-tab {
    position: absolute;
    top: -8px;
    right: calc((100% - 532px) / 2 - 6px);
    width: 140px;
    height: auto;
    z-index: 3;
    pointer-events: none;
    margin-top: 0px;
  }
  .sale-ad {
    padding-top: 5px;
    img {
      width: 242px;
      height: 54px;
    }
  }
  .float-animation {
    animation: float 1.5s linear infinite;
  }
  img {
    display: block;
    width: 532px;
    margin: 20px auto 0;
  }
  .button-tip {
    position: absolute;
    top: -10px;
    right: 38px;
    width: 190px;
    img {
      width: 100%;
    }
  }
  .tip {
    width: 100%;
    text-align: center;
    font-size: 24px;
    position: absolute;
    color: #fff;
    margin-top: 94px;
  }
  .button-tip-new {
    position: absolute;
    top: 6px;
    right: 119px;
    text-align: center;
    font-size: 22px;
    color: #fff;
    border-radius: 20px 20px 0 20px;
    background: #F31D20;
    padding: 8px 20px;
  }
  .button-tip-right {
    position: absolute;
    top: 20px;
    right: 40px;
    padding: 4px 20px;
    border-radius: 20px 20px 20px 0;
    font-weight: 700;
  }
  .button-tip-right-new {
    position: absolute;
    top: 5px;
    right: 80px;
    padding: 4px 10px;
    border-radius: 20px;
    background: rgb(254, 238, 194);
    font-size: 18px;
    color: #000;
    font-weight: normal;
  }
}
.pkg-button {
  width: 500px;
  height: 90px;
  position: relative;
  margin: var(--button-margin);
}
.agreement {
  width: 100%;
  height: 70px;
  &.top {
    height: 60px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 200px;
  }
  &.bottom {
    height: 40px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 100px;
  }
  &.top-top {
    height: 60px;
    width: 100%;
    position: absolute;
    left: 0;
    top: var(--top-agreement-top);
  }
  &.toast-top {
    height: 60px;
    width: 100%;
    position: absolute;
    left: 0;
    top: -330px;
  }
}
.agreement-bottom {
  position: absolute;
  bottom: -120px;
  left: 0;
  width: 100%;
  height: 40px;
  font-size: 24px;
  color: #999999;
  text-align: center;
  margin-top: 40px;
}
.agreement-section {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 34px;
  color: var(--agreement-text-color);
  font-weight: 400;
  margin: 30px 0 20px;
  font-size: 24px;

  .agreement-checkbox {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .agreement-link {
    color: var(--agreement-text-color);
    font-size: 24px;
    margin-left: 8px;
  }
}
.close-area {
  width: 100%;
  height: 100px;
}
.swiper-container {
  width: 524px;
  margin: 0 auto 24px;
  .swiper-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    ::v-deep .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: var(--swiper-bullet-bg);
      margin: 0 6px;
      border-radius: 50%;
      opacity: 1;
      &-active {
        background: var(--swiper-bullet-active-bg);
        opacity: 1;
      }
    }
  }
}
.packageLogo {
  ul {
    .price {
      position: static;
      margin-top: -6px;
    }
    .desc {
      margin-top: 32px;
    }
    .month-price {
      margin-top: -6px;
    }
    li {
      border: 2px solid var(--color-border);
      display: flex;
      flex-direction: column;
      // justify-content: center;
    }
    .tag {
      left: -2px;
    }
    .selected {
      border: 2px solid var(--color-border-selected);
      .icon-app {
        background: var(--color-logo-bg-selected);
      }
    }
    li:nth-child(2) {
      .icon-app {
        width: 100%;
      }
    }
    .icon-app {
      width: 100%;
      height: 64px;
      bottom: 0;
      left: 0px;
      right: 0;
      top: auto;
      margin: 0;
      background: var(--color-logo-bg);
      border-radius: 0 0 8px 8px;
      img {
        width: 155px;
      }
    }
  }
}
.singsong {
  .icon-plus {
    display: none;
  }
  .tag {
    left: -2px;
  }
  .tip {
    width: 168px;
    left: -2px;
    bottom: -2px;
  }
  ul {
    li {
      border: 2px solid var(--color-border);
    }
    .selected {
      border: 2px solid var(--color-border-selected);
    }
  }
  .icon-app {
    width: 147px;
    height: 28px;
    top: 115px;
    margin-left: -73.5px;
  }
}
.order-song-area {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  height: 70px;
}
::v-deep .swiper-pagination {
  position: static;
}
.new_coopenAdvertising {
  ::v-deep .present-vip-btn {
    margin-top: 10px;
  }
}
.hand {
  width: 130px;
  position: absolute;
  left: 495px;
  top: var(--hand-top);
  animation: shakeX 2.5s linear 0s infinite normal;
  animation-fill-mode: both;

  @keyframes shakeX {
    from,
    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: translate3d(-10px, 0, 0);
      transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
      -webkit-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }
  }
}
.hand-from-bottom {
  top: auto !important;
  bottom: 8vw;
}
.foot-bar {
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  margin: 0 18px;
  & > * {
    margin: 0;
    width: 280px;
  }
  .order-song-area {
    height: var(--button-height);
    background: url(https://qncweb-back1.ktvsky.com/20220211/vadd/1c86fb6069496a4893483becd5d8b119.png)
      no-repeat center;
    background-size: 100% auto;
    position: relative;
  }
  .pay-button {
    background: url(https://qncweb-back1.ktvsky.com/20220913/other/c11aec629531f85ed99911821a4a4340.png)
      no-repeat center;
    background-size: 100% auto;
    margin-top: 0 !important;
    position: relative;
  }
  .pay-button-tip {
    width: 90px;
    height: 34px;
    display: block;
    position: absolute;
    top: 10px;
    right: -10px;
  }
  div:only-child {
    width: 100%;
    background-image: url(https://qncweb-back1.ktvsky.com/20221116/vadd/b24fb8743b9cae805c76cf38f91d4f0c.png);
    background-size: 480px auto;
    margin: 0 auto;
  }
  &.home {
    .pay-button-tip {
      position: absolute;
    }
  }
  &.djhot {
    .pay-button-tip {
      position: absolute;
      top: 6px;
    }
  }
  &.search_tab {
    .pay-button-tip {
      position: absolute;
      top: 10px;
    }
  }
  &.kaiping_new_mianfei {
    margin-top: 70px;
    .pay-button {
      background-size: 460px auto;
      background-image: url(https://qncweb-back1.ktvsky.com/20220818/other/ba668aaef08a1ef4749da8de748c7a70.png);
      animation: breath 1s linear infinite;
    }
    @keyframes breath {
      0% {
        transform: scale(0.88);
      }
      50% {
        transform: scale(1);
      }
      100% {
        transform: scale(0.88);
      }
    }
  }
  &.maibabidian {
    &.search_tab > * {
      background-position: center;
    }
    div:only-child {
      width: 100%;
      background-image: url(https://qncweb-back1.ktvsky.com/20220225/vadd/ede138bf2f29ca04a963eff3994ee268.png);
      background-size: 360px auto;
    }
  }
}
.new-foot-bar {
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  margin: 44px 18px 20px;
  & > * {
    margin: 0;
    width: 280px;
  }
  .play-song {
    width: 280px;
    height: 90px;
    // margin: 5px auto 0;
    background: url(https://qncweb-back1.ktvsky.com/20230207/vadd/1394622249a8f419424c30a37ca20d9d.png) no-repeat center;
    background-size: 100% auto;
  }
  .pay-button {
    background: url(https://qncweb-back1.ktvsky.com/20230207/vadd/104d4b0c655987b367693dec88b0e555.png) no-repeat center;
    background-size: 100% auto;
    margin-top: 0!important;
    position: relative;
    height: 90px;
    animation-duration: 0.8s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: HeartBeat;
  }
  .pay-button-tip {
    display: none;
  }
}
@keyframes HeartBeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.pay_stay90 {
    display: flex;
    justify-content: space-around;
    margin: 40px 20px;
    div {
      width: 260px;
      height: 120px;
    }
  }
@keyframes float {
  50% {
    transform: translateY(-8px);
  }
  100% {
    transform: translateY(0);
  }
}
// end
// VIP专享热歌限定
.hotsongs {
  .hotsong-swiper {
    height: 45px;
    p {
      width: 290px;
      @include rowHide(1);
    }
    .song-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      .song-name {
        font-size: 32px;
        color: #fff;
        max-width: 7em;
        // @include rowHide(1);
      }
      .song-icon {
        width: 60px;
        height: auto;
        margin-left: 10px;
        position: relative;
        top: 3px;
      }
      .song-info {
        flex: 1;
        display: flex;
        align-items: center;
      }
      .song-user {
        width: 230px;
        display: flex;
        align-items: center;
      }
      .mike {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
      .song-tips {
        font-size: 28px;
        color: #eaff00;
      }
      .recomend-songs {
        color: #fff;
      }
    }
  }
}
// VIP专享热歌限定  --- end
.first-oldvip {
  .packages-ul {
    margin-top: 40px;
  }
  .hotsong-swiper {
    height: 42px;
    .song-item {
      padding: 0 25px;
      .song-name {
        font-size: 28px;
        color: #613218;
      }
      .song-tips {
        font-size: 26px;
        color: #F87A25;
      }
      .song-user {
        width: 220px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .recomend-songs {
        color: #F87A25;
        font-weight: 600;
      }
    }
  }
}
.count-to {
  ::v-deep span {
    padding: 0!important;

  }
}
.index-hot-song {
  .raise-box-content, .content-bg {
    width: 550px;
  }
  .packages-ul {
    li {
      width: 218px;
      height: 266px;
    }
    .desc {
      font-size: 32px;
    }
    .month-price {
      font-size: 40px;
    }
    .price {
      font-size: 20px;
      bottom: initial;
      top: 165px;
    }
  }
  .pay-button {
    height: 30vw;
  }
  .hotsong-swiper {
    width: 525px;
    height: 56px;
    background: #291AE4;
    border-radius: 9px;
    padding: 0 12px 0 20px;
  }
  .song-name {
    max-width: 232px;
  }
}
.second-home-toast {
  .raise-box-content, .content-bg {
    width: 490px;
  }
}
// 首页「点亮VIP」手指引导icon
.homevipicon {
  .hand {
    top: 38vw;
  }
}
// 关闭按钮测试2(底部弹窗)
.is-bottom-position {
  .raise-box-content {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    animation: lift-in 0.5s;
  }
  .content-bg {
    width: 100vw;
    display: flex;
    justify-content: flex-end;
  }
  .packages-ul {
    margin: 0 90px;
  }
  .content-out {
    animation: lift-out 0.5s;
  }
  .agreement {
    bottom: 20px;
  }
}
@keyframes lift-in {
  0% {
    bottom: -900px;
  }
  100% {
    bottom: 0;
  }
}
@keyframes lift-out {
  0% {
    bottom: 0;
  }
  100% {
    bottom: -900px;
  }
}
.position-bottom {
  justify-content: flex-end;
}
// 高清MV版歌曲（1080p）- 定制化样式
.mv {
  .order-song-area {
    height: 120px;
  }
  .raise-box-content, .content-bg {
    width: 690px;
  }
  .raise-box-content {
    margin-bottom: 50px;
  }
}
// -end
.first-tip-animation {
  position: absolute;
  top: 20px;
  right: 40px;
  width: 110px;
  height: 40px;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background-image: linear-gradient(179deg, #FF4141 0%, #F21E1E 98%);
  border-radius: 20px;
  animation: tada 1.5s linear infinite;
}

.search_tc_one {
  .pay-button {
    .tip {
      width: 110px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      background: #F72829;
      color: #fff;
      font-size: 18px;
      position: absolute;
      top: -20px;
      right: 40px;
    }
  }
}
.search_tc_role4 {
  .packages-ul {
    li {
      border-radius: 20px;
    }
  }
  h1.expire {
    position: absolute;
    width: 100%;
    text-align: center;
    z-index: 100;
    top: 200px;
    font-size: 48px;
    @include gradientText2(90deg, #895809 3.65%, #5C2F0D 100%);
  }
}
.bottom_big {
  .packages-ul {
    height: 236px;
    margin: 0 60px;
    li {
      width: 200px;
      height: 236px;
    }
    .desc {
      font-size: 30px;
    }
    .month-price {
      font-size: 28px;
      margin: 0;
      ::v-deep span{
        font-size: 48px;
      }
    }
    .price {
      font-size: 20px;
      bottom: initial;
      top: 160px;
    }
  }
  .tag {
    position: absolute;
    left: var(--tag-left);
    top: var(--tag-top);
    font-size: var(--tag-size);
    span {
      line-height: var(--tag-line-height);
      border-radius: var(--tag-radius-new);
    }
  }
  .selected {
    .tag {
      position: absolute;
      left: var(--tag-left);
      span {
        background: var(--tag-bg-selected);
        color: var(--tag-color-selected);
      }
    }
  }
  .tip {
    border-radius: 0 0 2.4vw 2.4vw;
  }
  .present-vip-btn {
    width: 626px;
    .point{
      position: absolute;
      left: 60px;
      width: 100px;
    }
  }
  .agreement {
    bottom: 40px;
  }
  .first-tip-animation {
    position: absolute;
    top: 20px;
    right: 80px;
  }
}
.search_tc_role2 {
  .packages-ul {
    margin: 0 30px;
  }
  .tip {
    border-radius: var(--bottom-tip-radius);
  }
  .topTip {
    border-radius: 5px 5px 0 0;
  }
  .agreement-bottom {
    bottom: -60px;
  }
}
.cloud-song {
  .agreement {
    height: 100px
  }
}
.home-avatar {
  .top-close {
    opacity: 0.5;
  }
}

.user-avatar {
  position: absolute;
  width: var(--avatar-frame-width);
  height: var(--avatar-frame-height);
  z-index: 100;
  left: 50%;
  margin-left: calc(var(--avatar-frame-width) / -2);
  top: calc(var(--avatar-frame-height) / -2);
  .user_img {
    width: var(--user-img-width);
    height: var(--user-img-height);
    border: 3px solid #FFFFFF;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  span {
    width: var(--avatar-frame-width);
    height: var(--avatar-frame-height);
    position: absolute;
    top: 0;
    left: 0;
    background: var(--avatar-frame-bg) no-repeat center center;
    background-size: 100% auto;
  }
  .crown-icon {
    position: absolute;
    top: -40px;
    right: -20px;
    width: var(--crown-width);
    height: var(--crown-height);
  }
  // 自定义皇冠图标样式
  .crown-icon-custom {
    position: absolute;
    top: -30px;
    right: 0px;
    width: var(--crown-width);
    height: var(--crown-height);
    z-index: 100;
  }
}
.avatar_frame {
  position: absolute;
  top: 80px;
  left: 50%;
  margin-left: calc(var(--avatar-frame-width) / -2);
  .user_img {
    width: var(--user-img-width);
    height: var(--user-img-height);
    border: none;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.user-avatar1 {
  position: absolute;
  top: 15px;
  span {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url(https://qncweb.ktvsky.com/20250114/vadd/ca45df6b10ac19f79c8f141b7d10918e.png) no-repeat center center;
    background-size: 100% auto;
  }
}
.avatar-text {
  position: absolute;
  top: 20px;
  left: 220px;
  width: 310px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
  font-size: 35px;
  font-weight: 500;
  color: #fff;
  .avatar-new {
    width: 70px;
    height: 70px;
    position: relative;
    img {
      border-radius: 50%;
    }
    span {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: url(https://qncweb.ktvsky.com/20250114/vadd/ca45df6b10ac19f79c8f141b7d10918e.png) no-repeat center center;
      background-size: 100% auto;
    }
  }
}
.avatar-text-new {
  position: absolute;
  width: 340px;
  top: 40px;
  left: 200px;
  .avatar-new {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    img{
      border: 3px solid #BD9B5C;
    }
  }
  .expire-img {
    display: none;
  }
}
.avatar-text-left {
  position: absolute;
  width: 340px;
  top: 30px;
  left: 40px;
  color: #AD7C00;
}
.avatar-and-name {
  position: absolute;
  width: 340px;
  top: 34px;
  left: 24px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #251053;
  .expire-img {
    display: none;
  }
  .avatar-new {
    width: 52px;
    height: 52px;
    margin-right: 18px;
    img{
      border: 2px solid #ffffff;
    }
  }
  // 用户昵称文本溢出处理
  .user-nickname {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
h1.expire {
  position: absolute;
  width: 100%;
  text-align: center;
  z-index: 100;
  top: 60px;
  font-size: 48px;
  color: #6A3600;
}
.pay-button-animation {
  width: 468px;
  height: 90px;
  margin: 40px auto 0;
  animation: heartBeat 2s linear infinite;
  img {
    width: 100%;
    height: 100%;
  }
}
.pay-button-caliang {
  width: 530px;
  height: 90px;
  border-radius: 45px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  img {
    position: relative;
    width: 530px;
    height: 90px;
    margin: 0 auto;
  }
  // 添加擦亮动效
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    opacity: .73;
    background-image: linear-gradient(106deg, #e8e0ff00 24%, #ffffff 70%);
    transform: skewX(-20deg);
    animation: flicker-shine 3s ease-in-out infinite;
    z-index: 1;
  }
}
// 擦亮动效关键帧动画
@keyframes flicker-shine {
  0% {
    left: -100%;
  }
  20% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}
.month_first {
  .packages-ul {
    li {
      width: 180px;
      height: 240px;
      &:first-child {
        width: 240px;
      }
    }
    .desc {
      font-size: 30px;
      font-weight: normal;
    }
    .month-price {
      font-size: 28px;
      margin: 0;
      ::v-deep span{
        font-size: 44px;
      }
    }
    .price {
      font-size: 20px;
      bottom: initial;
      top: 160px;
    }
  }
  .tag {
    position: absolute;
    top: var(--tag-top);
    font-size: 20px;
    span {
      line-height: 40px;
      border-radius: 10px 0px 10px 0px;
    }
  }
  .tip {
    border-radius: 0 0 4px 4px;
  }
}
.pay-button-countdown {
  margin: var(--countdown-margin);
}
.countdown-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 574px;
  height: var(--countdown-height);
  margin: 0 auto;
  background: var(--countdown-bg);
  border-radius: calc(var(--countdown-height) / 2);
  color: var(--countdown-color);
  font-size: 36px;
  font-weight: 600;
  .countdown{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    color: var(--countdown-color);
    span {
      display: inline-block;
      width: 50px;
      text-align: center;
    }
  }
  .countdown1 {
    width: 240px;
    .countdown-m {
      width: 60px;
    }
  }
  .countdown-icon {
    width: 30px;
    height: 30px;
    margin: 0 10px;
  }
}
.month_width {
  .packages-ul {
    li {
      width: 168px;
      height: 240px;
      &:nth-child(2) {
        width: 268px;
      }
    }
    .desc {
      font-size: 26px;
      margin-top: 40px;
    }
    .month-price {
      font-size: 28px;
      margin: 10px 0;
      ::v-deep span{
        font-size: 40px;
      }
    }
    .price {
      font-size: 20px;
      bottom: initial;
      top: 160px;
    }
  }
  .tip {
    border-radius: 0 0 4px 4px;
  }
}
.tap-top {
  width: 220px;
  height: 70px;
  background: url(https://qncweb-back1.ktvsky.com/20241128/vadd/9f3bf0ef22e09f0dcf8ab83230908f02.png) no-repeat center center;
  background-size: contain;
  margin: 0 auto 10px;
  font-size: 24px;
  font-weight: 600;
  color: #FFFFFF;
  text-align: center;
  line-height: 60px;
}
.tip-border-radius {
  .tip {
    border-radius: 0 0 5px 5px;
  }
}
.flex-container {
  display: flex;
}
.top-user-count {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: #000000;
  font-weight: 500;
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  overflow: hidden;

  .count-text {
    position: relative;
    width: 100%;
  }
  .count-number {
    display: inline-block;
    margin: 0 12px;
    color: #FF1818;
    font-weight: 600;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.5s ease-out;
}

.slide-up-enter {
  opacity: 0;
  transform: translateY(40px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-40px);
}

.slide-up-enter-to,
.slide-up-leave {
  opacity: 1;
  transform: translateY(0);
}
// 立冬主题
.cold-theme {
  .user_img {
    border: 6px solid #ffffff;
  }
  .user-avatar span {
    padding: 6px;
    background: var(--avatar-frame-bg) no-repeat center center;
    background-size: 112px auto;
  }
  .expire {
    top: 80px;
    font-size: 48px;
    color: #0D2E6B;
  }
  .crown-icon {
    width: 78px;
    height: 78px;
    position: absolute;
    top: -39px;
    right: -12px;
  }
}
.new_oldvip_kaiping {
  .config-title-area {
    margin-bottom: 100px !important;
  }
}
.kaiping_vip_two {
  .agreement {
    &.top-top {
      position: absolute;
      left: 0;
      top: -100px!important;
    }
  }
}
.new-theme {
  .config-sub-title {
    margin-top: 26px!important;
  }
  .selected {
    .tip {
      border-radius: 0 0 0 0!important;
    }
  }
}
// role3 首页头像弹窗：背景图底部透明，协议热区单独定位
.is-bottom-position {
  .agreement.role3-home-avatar-agreement {
    position: relative;
    left: 0;
    width: 100%;
    bottom: 6vw;
    height: 9.333vw;
  }
}
</style>
